module.exports = __webpack_public_path__ + "media/InsanePyramid.66318265.mp4";